import React from 'react';
import { Link } from 'react-router';
import prop from 'ramda/es/prop';
import omit from 'ramda/es/omit';
import pipe from 'ramda/es/pipe';
import path from 'ramda/es/path';

import api from 'app/actions/api';
import { popup } from 'app/common/actions/popup';
import { Trans } from 'react-i18next';
import i18n from 'app/i18n';
import { getSignByCode } from 'app/common/components-next/currency';


/**
/* Подписки month_daily
*/

export const SUB_PREPAYD_REQUEST = 'SUB_PREPAYD_REQUEST';
export const SUB_PREPAYD_SUCCESS = 'SUB_PREPAYD_SUCCESS';
export const SUB_PREPAYD_FAILURE = 'SUB_PREPAYD_FAILURE';

const subPrepaydRequest = () => ({
  type: SUB_PREPAYD_REQUEST,
});

const subPrepaydSuccess = data => ({
  type: SUB_PREPAYD_SUCCESS,
  payload: data,
});

const subPrepaydFailure = payload => ({
  type: SUB_PREPAYD_FAILURE,
  payload,
});

export const subPrepayd = (subId, monthsNumber, sms) => async (dispatch, getState) => {
  const { country_iso_code: code } = getState().dealer;
  const postData = {
    id: subId,
    months_number: monthsNumber,
    sms,
  };
  dispatch(subPrepaydRequest());

  try {
    const res = await api('cabinet/subscriptions/prepaid', 'post', { data: postData });
    const data = pipe(
      prop('data'),
      omit(['result'])
    )(res);
    dispatch(subPrepaydSuccess({ subs: data }));
    dispatch(popup(i18n.t('app:request_prepayd_success')));
    return true;
  } catch (error) {
    const errCode = path(['response', 'status'], error);
    const amount = path(['response', 'data', 'amount'], error);

    if (errCode === 403) {
      const amountCurrency = `${amount}${getSignByCode(code)}`;

      dispatch(subPrepaydFailure({
        error,
        err: <span>
          <Trans
            i18nKey="app:request_not_enough_funds"
            values={{ amount: amountCurrency }}
          >
            {'Недостаточно {{amount}} на счету. '}
            <Link to={`/finances/fund/refill/self/primary/step2?amount=${amount}`}>
              {'Пополнить'}
            </Link>
          </Trans>
        </span>,
        errCode,
      }));

      return false;
    }
    dispatch(subPrepaydFailure({
      error,
      err: i18n.t('app:request_prepayd_failed'),
      errCode,
    }));
    return false;
  }
};
